export type EconomicZone = { value: number; label: string };
export type CriticalityType = {
  value: "greatest" | "hms1" | "hms3" | "dr";
  label: string;
};
export type State = { value: number; label: string };
export type Criticality = { value: number; label: string };

export const CRITICALITY_STATES = [
  { value: 1, label: "(TK1) Som ny" },
  { value: 2, label: "(TK2) Noe redusert" },
  { value: 3, label: "(TK3) Svekket" },
  { value: 4, label: "(TK4) Betydelig svekket" },
  { value: 5, label: "(TK5) Feil" },
];

export const CRITICALITIES: Array<Criticality> = [
  { value: 1, label: "(K1) Ubetydelig" },
  { value: 2, label: "(K2) Mindre viktig" },
  { value: 3, label: "(K3) Medium" },
  { value: 4, label: "(K4) Viktig" },
  { value: 5, label: "(K5) Svært viktig" },
];

export const ECONOMIC_ZONES: Array<EconomicZone> = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
];

export const CRITICALITY_TYPES: Array<CriticalityType> = [
  { value: "dr", label: "ETLS" },
  { value: "hms1", label: "HMS1" },
  { value: "hms3", label: "HMS3" },
];
